module.exports = __webpack_public_path__ + "img/HA2511-150.7538cb2a.jpg";